// extracted by mini-css-extract-plugin
module.exports = {"rejectionReason":"styles_rejectionReason__3Onfo","messageContainer":"styles_messageContainer__3aMam","link":"styles_link__2WDMK"};